<div [class.container-fluid]="!embedded" [class.mt-3]="!embedded">
    <div class="card">
        <div class="card-header"><strong>{{ 'kobeac.documents' | transloco }}</strong></div>
        <div class="card-body">
            <!-- 顧客未紐付け: 単独ページは案内、埋め込み(ダッシュボード)は空状態を表示 -->
            <div *ngIf="!embedded && checkedCustomer && !hasCustomer" class="text-center text-muted py-5">
                {{ 'kobeac.no_customer_documents' | transloco }}<br>
                {{ 'kobeac.contact_admin' | transloco }}
            </div>
            <div *ngIf="embedded && checkedCustomer && !hasCustomer" class="text-muted">{{ 'kobeac.no_documents_period' | transloco }}</div>

            <ng-container *ngIf="hasCustomer">
            <p class="text-muted">{{ 'kobeac.documents_desc' | transloco }}</p>
            <nav class="mb-2">
                <span *ngFor="let c of breadcrumbs; let last = last">
                    <a href="javascript:void(0)" (click)="goto(c.path)" *ngIf="!last">{{ c.name }}</a>
                    <strong *ngIf="last">{{ c.name }}</strong>
                    <span *ngIf="!last"> / </span>
                </span>
                <button class="btn btn-sm btn-secondary ml-2" (click)="list()">{{ 'kobeac.refresh' | transloco }}</button>
            </nav>
            <table class="table table-sm table-hover">
                <thead>
                <tr>
                    <th>{{ 'kobeac.name_label' | transloco }}</th>
                    <th>{{ 'kobeac.type' | transloco }}</th>
                    <th class="text-right">{{ 'kobeac.size' | transloco }}</th>
                    <th>{{ 'kobeac.updated_at' | transloco }}</th>
                    <th>{{ 'kobeac.actions' | transloco }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let e of entries">
                    <td>
                        <a href="javascript:void(0)" (click)="open(e)">
                            <i class="fa" [ngClass]="e.type == 'dir' ? 'fa-folder' : 'fa-file'"></i> {{ e.name }}
                        </a>
                    </td>
                    <td>{{ (e.type == 'dir' ? 'kobeac.folder' : 'kobeac.file') | transloco }}</td>
                    <td class="text-right">{{ e.type == 'dir' ? '-' : convertSize(e.size) }}</td>
                    <td>{{ e.date }}</td>
                    <td>
                        <button *ngIf="e.type != 'dir'" class="btn btn-sm btn-link" (click)="download(e)">{{ 'common.download' | transloco }}</button>
                    </td>
                </tr>
                <tr *ngIf="!loading && entries.length == 0">
                    <td colspan="5" class="text-center text-muted">{{ 'kobeac.no_documents' | transloco }}</td>
                </tr>
                </tbody>
            </table>
            </ng-container>
        </div>
    </div>
</div>
